import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=27df5c88&scoped=true&"
import script from "./ChangeEmail.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=27df5c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df5c88",
  null
  
)

export default component.exports